import { UserInfo } from "@/entities/account/account.types"
import {
  DomainTypeEnum,
  TranslateLanguageTypeEnum,
} from "@/entities/translation/translation.types"
import { z } from "zod"
import {
  FileJobSchema,
  GlossaryTaskMappingsSchema,
  JobSchema,
  NonMemberQuotationSchema,
  OwnershipInfoSchema,
  ProjectActionItemsSchema,
  ProjectSchema,
  UnitRateInfoSchema,
  UploadActionItemsSchema,
  UploadProjectSchema,
} from "./project.schema"

export enum ProjectStatusEnum {
  QuotationInProgress = "quotation_in_progress",
  QuotationCompleted = "quotation_completed",
  QuotationFailed = "quotation_failed",
  TranslationInProgress = "translation_in_progress",
  TranslationDelivered = "translation_delivered",
  PaymentReceived = "payment_received",
  OrderCancelled = "order_cancelled",
}

export enum CreateRequestEnum {
  Domain,
  ExpectedDeliveryDate,
  UploadFile,
  Memo,
  PersonalInfo,
  Summary,
}

export type ProjectActionItems = z.infer<typeof ProjectActionItemsSchema>
export type ProjectJob = z.infer<typeof JobSchema>
export type OwnershipInfoType = z.infer<typeof OwnershipInfoSchema>
export type UploadActionItems = z.infer<typeof UploadActionItemsSchema>
export type FileJob = z.infer<typeof FileJobSchema>
export type Project = z.infer<typeof ProjectSchema>
export type UploadProject = z.infer<typeof UploadProjectSchema>
export type UnitRateInfo = z.infer<typeof UnitRateInfoSchema>
export type NonMemberQuotation = z.infer<typeof NonMemberQuotationSchema>
export type GlossaryTask = z.infer<typeof GlossaryTaskMappingsSchema>

export interface ProjectFormType {
  projectForm: UploadProject
  setProjectForm: (
    field: keyof UploadProject,
    value:
      | string
      | DomainTypeEnum
      | TranslateLanguageTypeEnum
      | UploadActionItems[]
  ) => void
}

export interface ProjectManageDialogProps {
  project: Project
  userInfo: UserInfo | null
  isOpen: boolean
  onClose: () => void
}
